<template>
  <div class="container">
    <v-otp-input
      class="otp-input"
      input-classes="otp-input__element"
      separator="<span class='otp-input__separator' />"
      :num-inputs="maxlength"
      :should-auto-focus="true"
      @on-blur="onBlur"
      @on-change="onInput"
    />
    <span class="error" v-if="error">
      <img src="@/assets/img/1x/error_icon.png" alt="Ícono error" />
      <p>{{ error }}</p>
    </span>
  </div>
</template>

<script>
import VOtpInput from "@bachdgvn/vue-otp-input";
export default {
  name: "otp-input",
  components: {
    VOtpInput
  },
  props: {
    value: String,
    name: String,
    maxlength: Number,
    validationError: String,
    analyticsTypology: String
  },
  data() {
    return {
      focused: false,
      checked: false
    };
  },
  replace: false,
  mounted() {
    this.$emit("input", "");
  },
  computed: {
    error() {
      if (this.checked) {
        if (this.validationError) {
          return this.validationError;
        } else if (this.isVoid()) {
          return "Tenés que ingresar este dato";
        } else if (!this.isValid()) {
          return "El número no es válido";
        } else if (this.$store.getters.getCelular().error) {
          return "El código ingresado es incorrecto. Intentá nuevamente.";
        }
      }
      return null;
    }
  },
  methods: {
    onInput(val) {
      this.$emit("input", val);
    },
    onBlur() {
      this.focused = false;
      this.tmpHint = "";
      this.$emit("onBlur");
    },
    checkValid() {
      this.checked = true;
      return this.isValid();
    },
    isVoid() {
      return this.value == null || this.value.trim() === "";
    },
    isValid() {
      if (this.required) {
        return this.value && this.value.length === this.maxlength;
      }
      return true;
    }
  }
};
</script>

<style scoped>
input {
  /* Dar un poco de espacio para "centrar" el texto verticalmente */
  border-top: 17px solid transparent;
}

.otp-input >>> .otp-input__element {
  border: 0;
  border-bottom: 1px solid #666666;
  background-color: #f4f4f4;
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  font-size: 20px;
  color: #121212;
  padding: 0;
  text-align: center;
}

.otp-input >>> .otp-input__separator {
  display: block;
  width: 8px;
}

/* Estilos para errores */
input.error {
  background: #fcdfdf;
}

span.error {
  margin-left: 16px;
  margin-top: 8px;
  display: block;
}

span > img,
span > p {
  display: inline-block;
  vertical-align: top;
}

span > img {
  width: 16px;
}

span > p {
  margin-left: 2px;
  margin-top: 0px;
  margin-bottom: 0px;
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  font-size: 12px;
  line-height: 1.33;
  color: #121212;
}

/* Subhint */
span.subhint {
  display: block;
  padding-top: 5px;
}
</style>
